module.exports = __webpack_public_path__ + "static/img/logo4.fb9e33d7.png";